// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1Yg2Z","buttons":"RemoveExpirationActionButtons_buttons__3q-Ry"};